<template>
  <div class="servicenotice has-text-centered">
    <b-notification v-model="isActiveNotice"
      class="is-radiusless"
      type="is-dark"
      aria-close-label="Close notification"
      role="alert"
      >
      <router-link to="/beta">{{ $t("beta.betanotice") }}</router-link>
    </b-notification>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActiveNotice: true,
    };
  },
};
</script>
